import React from 'react';
import { Button } from 'react-bootstrap';

const HeaderTitle: React.FC<any> = ({
	title,
	type,
	onShowModal,
	isEdit = false,
	isSelf = false,
}) => {
	return (
		<div className="white-box-heading d-flex align-items-center justify-content-between">
			<h3 className="fw-bold mb-0">{title}</h3>
			{isSelf && type && (
				<Button className="edit-btn rounded-circle p-0 border-0" onClick={() => onShowModal(type)}>
					<i className={isEdit ? 'ri-edit-line' : 'ri-add-line'}></i>
				</Button>
			)}
		</div>
	);
};

export default HeaderTitle;
